const Badge = ({ text, className = "", children, ...props }) => {
  return (
    <span
      className={`badge badge-${className}`}
      {...props}
    >
      {text || children}
    </span>
  );
};

export default Badge;
